import React from 'react';
import Typography from './common/Typography';
import { IconButton } from './common/Button';

const ItemTitleSection = ({
  title,
  handleDeleteButton,
  handleAddButton,
  addButton = false,
  buttonIcon = true,
}) => {
  return (
    <div className="displayFlex" style={{ gap: '10px' }}>
      <Typography variant="body1Bold">{title}</Typography>
      <div className="titleLine"></div>
      {buttonIcon && (
        <IconButton
          deleteIcon={!addButton}
          addIcon={addButton}
          variant="outline"
          size="small"
          color="gray"
          onClick={addButton ? handleAddButton : handleDeleteButton}
          alt={addButton ? `${title} 상세보기` : `${title} 삭제`}
        />
      )}
    </div>
  );
};

export default ItemTitleSection;
